import React, { Fragment, useEffect, useState } from 'react';
import Footer from '../Footer/Footer';
import Loader from '../../loader/Loader';
import PageSEO from '../Common/PageSEO';
import {
    FeatureHero,
    FeatureCtaButton,
    FeatureSection,
    FeatureCta
} from '../Common/FeatureContent';
import { useLocale } from '../../localization/LocaleContext';
import { ROUTE_PATHS } from '../../localization/constants';
import './resourcePages.css';

function GuidesMain(){
    const { t, toLocalizedPath, locale } = useLocale();
    const p = (key) => t(`resourcePages.guides.${key}`);

    const [loader, setLoader] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setLoader(true), 1000);
        return () => clearTimeout(timer);
    }, []);

    if (!loader) {
        return <Loader/>;
    }

    const guides = [1, 2, 3, 4, 5, 6, 7, 8].map((num) => ({
        title: p(`guide${num}Title`),
        description: p(`guide${num}Description`)
    }));

    return(
        <Fragment>
            <PageSEO title={p('metaTitle')} description={p('metaDescription')} path={ROUTE_PATHS.guides} locale={locale} />

            <FeatureHero
                eyebrow={p('eyebrow')}
                title={p('heroTitle')}
                highlight={p('heroHighlight')}
                subtitle={p('heroSubtitle')}
                cta={<FeatureCtaButton to={toLocalizedPath('helpCenter')}>{p('heroCta')}</FeatureCtaButton>}
            />

            <FeatureSection alt title={p('guidesSectionTitle')} description={p('guidesSectionDescription')}>
                <div className="rp-list">
                    {guides.map((guide, idx) => (
                        <div className="rp-list-item" key={idx}>
                            <div className="rp-list-item-number">{idx + 1}</div>
                            <div>
                                <div className="rp-list-item-title">{guide.title}</div>
                                <p className="rp-list-item-description">{guide.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </FeatureSection>

            <FeatureCta
                title={p('ctaTitle')}
                description={p('ctaDescription')}
                ctaTo={toLocalizedPath('helpCenter')}
                ctaLabel={p('ctaButton')}
            />

            <Footer/>
        </Fragment>
    );
}

export default GuidesMain;
